<script setup lang="ts">
import { defineProps } from 'vue'

const emits = defineEmits(['click'])

const props = defineProps({
  id: {
    type: String,
  },
  className: {
    type: String,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  raised: {
    type: Boolean,
    default: false,
  },
  outlined: {
    type: Boolean,
    default: false,
  },
  link: {
    type: Boolean,
    default: false,
  },
  rounded: {
    type: Boolean,
    default: false,
  },
  href: {
    type: String,
    default: '#',
  },
  external: {
    type: Boolean,
    default: false,
  },
})

const variants = computed(() => {
  let style = 'flex items-center justify-center cursor-pointer px-4 py-3 transition-colors ease-in-out text-nowrap '
  const normalStyle = 'bg-[#2626BF] text-white hover:bg-[#3E3EF7] '
  const raised = 'shadow-[0px_4px_4px_rgba(46,46,229,0.25)] '
  const outlinedStyle = 'bg-white text-[#2626BF] border border-[#2626BF] hover:bg-[#E0EBFF] '

  if (props.rounded) {
    style = style + 'rounded-full '
  } else {
    style = style + 'rounded-xl '
  }

  if (!props.outlined) {
    style = style + normalStyle
  } else {
    style = style + outlinedStyle
  }

  if (props.raised) {
    style = style + raised
  }

  return style
})

const onClick = async (event: unknown) => {
  emits('click', event)
}
</script>

<template>
  <nuxt-link
    v-if="link"
    :id="id"
    :to="href"
    :class="`${variants}`"
    @click="onClick"
    v-bind="{external: external}"
  >
    <UiLoaderSpinner class="ml-2" v-if="loading" />
    <slot>
    </slot>
  </nuxt-link>
  <button v-else
    :id="id"
    :class="`${variants}`"
    @click="onClick"
    >
      <UiLoaderSpinner class="ml-2" v-if="loading" />
      <slot>
      </slot>
  </button>
</template>
